import React from 'react';
import { Target, TrendingUp, Rocket, Sparkles } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  target: Target,
  'trending-up': TrendingUp,
  rocket: Rocket,
  spark: Sparkles
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Investment <span className="text-emerald-600">Strategy</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our thematic approach capitalizes on India's vibrant primary market ecosystem through strategic diversification
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-gray-50 rounded-3xl p-8 border border-gray-200 hover:border-emerald-200 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Key Objectives */}
        <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Key Investment Objectives
            </h3>
            <p className="text-lg text-gray-600">
              Our strategic approach focuses on three core principles
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 bg-emerald-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Maximize Alpha</h4>
              <p className="text-gray-600">Investing before public price discovery</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Rocket className="w-6 h-6 text-white" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Optimize Liquidity</h4>
              <p className="text-gray-600">Participating in multiple IPO rounds</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-emerald-700 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Target className="w-6 h-6 text-white" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Support SMEs</h4>
              <p className="text-gray-600">Providing growth capital in pre-IPO phases</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};